module.exports = __webpack_public_path__ + "static/media/img_7.5232c8cd.jpg";